<div style="display:block">
	<div style="width:100%">
		<p style="font-size:15pt;">hay etiquetas ya impresas, desea continuar?</p>
	</div>
	<div style="text-align:center">
	  <button mat-button [mat-dialog-close]="false">Cancelar</button>
	  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Imprimir</button>
	</div>
</div>	